import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Table, Modal } from "react-bootstrap";
import api from "../axiosConfig";
import { useLocation , useNavigate } from "react-router-dom";

const RegistrarPagoYMembrete = () => {
  
const location = useLocation();
const navigate = useNavigate();

const {
  membrete_id,
  cliente_id,
  cita_id,
  estado_pago_id,
  tipos_membrete,
  direccion_id,
  observaciones,
} = location.state || {};

  const [formPago, setFormPago] = useState({
  cita_id: "",
  cliente_id: "",
  estado_pago_id: "",
  monto: "",
  tipo_pago_id: "",
  observacion_pago: "",
});

const [formMembrete, setFormMembrete] = useState({
  cita_id: "",
  cliente_id: "",
  estado_pago_id: "",
  tipos_membrete: [],
  direccion_id: "",
  observaciones: "",
});

  const [pagos, setPagos] = useState([]);
  const [membretes, setMembretes] = useState([]);
  const [direcciones, setDirecciones] = useState([]);

  // Catálogos
  const [clientes, setClientes] = useState([]);
  const [citas, setCitas] = useState([]);
  const [citasFiltradas, setCitasFiltradas] = useState([]);
  const [tiposPago, setTiposPago] = useState([]);
  const [tiposMembrete, setTiposMembrete] = useState([]);
  const [estadosPago, setEstadosPago] = useState([]);
  // editar pagos - membrete
  const [editandoPago, setEditandoPago] = useState(false);
  const [idPagoActual, setIdPagoActual] = useState(null);

  
const [editandoMembrete, setEditandoMembrete] = useState(false);
const [idMembreteActual, setIdMembreteActual] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [direccionEditando, setDireccionEditando] = useState(null);
  const [nuevaDireccion, setNuevaDireccion] = useState({
  nombre: "",
  direccion: "",
  estado_provincia: "",
  codigo_postal: "",
});
const [busquedaCliente, setBusquedaCliente] = useState("");
const [filtroEstadoPago, setFiltroEstadoPago] = useState("");

//alertas
const [mensaje, setMensaje] = useState(null);

const [pagina, setPagina] = useState(1);
const [totalPagos, setTotalPagos] = useState(0);
const pagosPorPagina = 20;

  useEffect(() => {
    cargarPagos();
    cargarMembretes();
    cargarDirecciones();
    cargarClientes();
    cargarTodasLasCitas();
    cargarCatalogos();
    cargarPagos();
  }, [pagina, filtroEstadoPago]);

  const mostrarMensaje = (tipo, texto) => {
  setMensaje({ tipo, texto });
  setTimeout(() => setMensaje(null), 4000); // se oculta en 4s
};

  //para navegar desde generar membrete
   useEffect(() => {
  if (cliente_id && cita_id) {
    setFormMembrete({
      cliente_id: cliente_id.toString(),
      cita_id: cita_id.toString(),
      estado_pago_id: estado_pago_id?.toString() || "",
      tipos_membrete: tipos_membrete || [],
      direccion_id: direccion_id || "",
      observaciones: observaciones || "",
    });

     cargarCitasPorCliente(cliente_id).then(() => {
      setFormPago((prev) => ({
        ...prev,
        cliente_id: cliente_id.toString(),
        cita_id: cita_id?.toString() || "",
        estado_pago_id: estado_pago_id?.toString() || "",
      }));

    if (membrete_id) {
    setEditandoMembrete(true);
    setIdMembreteActual(membrete_id); // importante: pasa el id real del membrete
  }
});
  }
}, [cliente_id, cita_id, estado_pago_id, tipos_membrete, direccion_id, observaciones, membrete_id]);
  

  const clientesFiltrados = clientes.filter((c) => {
  const texto = busquedaCliente.toLowerCase();
  return (
    (c.nombres || "").toLowerCase().includes(texto) ||
    (c.apellidos || "").toLowerCase().includes(texto) ||
    (c.doc_identificacion || "").toLowerCase().includes(texto) ||
    (`${c.nombres || ""} ${c.apellidos || ""}`.toLowerCase().includes(texto))
  );
});

  const cargarCatalogos = async () => {
    try {
      const tiposRes = await api.get("/catalogos/tipos-pago");
      setTiposPago(tiposRes.data);

      const tiposMembreteRes = await api.get("/catalogos/tipos-membrete");
      setTiposMembrete(tiposMembreteRes.data);

      const estadosRes = await api.get("/catalogos/estados-pago");
      setEstadosPago(estadosRes.data);
    } catch (error) {
      console.error("Error cargando catálogos:", error);
    }
  };

  const cargarClientes = async () => {
    try {
      const res = await api.get("/clientes/");
      setClientes(res.data.resultados || res.data);
    } catch (error) {
      console.error("Error cargando clientes:", error);
    }
  };

  const cargarTodasLasCitas = async () => {
    try {
      const res = await api.get("/citas/");
      setCitas(res.data.resultados || res.data);
    } catch (error) {
      console.error("Error cargando citas:", error);
    }
  };

  const cargarCitasPorCliente = async (clienteId) => {
    if (!clienteId) return;
    try {
      const res = await api.get(`/citas/por-cliente/${clienteId}`);
      const añoActual = new Date().getFullYear();
      const citasDelAñoActual = (res.data || []).filter((cita) => {
        const añoCita = new Date(cita.fecha).getFullYear();
        return añoCita === añoActual;
      });
      setCitasFiltradas(citasDelAñoActual);
    } catch (error) {
      console.error("Error cargando citas del cliente:", error);
      setCitasFiltradas([]);
    }
  };

   const obtenerMotivoDeCita = (citaId, clienteId) => {
    const cita = citas.find((c) => c.id === parseInt(citaId));
    if (!cita) return "";

    // Si el cliente es principal
    if (cita.cliente_principal && cita.cliente_principal.id === parseInt(clienteId)) {
      return cita.motivo_cita?.nombre || "Sin motivo";
    }

    // Si es acompañante
    const acompanante = cita.acompanantes?.find(
      (a) => a.cliente?.id === parseInt(clienteId)
    );
    if (acompanante) {
      return acompanante.motivo?.nombre || "Sin motivo";
    }

    return "Sin motivo";
  };

  const cargarPagos = async () => {
  try {
    const skip = (pagina - 1) * pagosPorPagina;
    const res = await api.get("/pagos/", {
      params: {
        skip,
        limit: pagosPorPagina,
        estado_pago_id: filtroEstadoPago || undefined,
      },
    });

    setPagos(res.data.resultados || []);
    setTotalPagos(res.data.total || 0);
  } catch (err) {
    console.error("Error al cargar pagos:", err);
    setPagos([]);
  }
};

  const cargarMembretes = async () => {
  try {
    const res = await api.get("/membretes/");
    setMembretes(Array.isArray(res.data) ? res.data : []);
  } catch (error) {
    console.error("Error cargando membretes:", error);
    setMembretes([]);
  }
};

  const cargarDirecciones = async () => {
    try {
      const res = await api.get("/direcciones-envio/");
      setDirecciones(res.data);
    } catch (error) {
      console.error("Error cargando direcciones:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormMembrete({ ...formMembrete, [name]: value });

    // Si cambia el cliente, cargamos sus citas
    if (name === "cliente_id") {
      cargarCitasPorCliente(value);
    }
  };

  const handleTiposMembreteForm = (e) => {
    const value = parseInt(e.target.value);
    let seleccionados = [...formMembrete.tipos_membrete];
    if (e.target.checked) {
      seleccionados.push(value);
    } else {
      seleccionados = seleccionados.filter((id) => id !== value);
    }
    setFormMembrete({ ...formMembrete, tipos_membrete: seleccionados });
  };

  

  const handleCrearDireccion = async () => {
  if (!nuevaDireccion.nombre || !nuevaDireccion.direccion) {
    mostrarMensaje("warning", "Ingrese los campos obligatorios de la dirección.");
    return;
  }

  try {
    const res = await api.post("/direcciones-envio/", {
      nombre: nuevaDireccion.nombre,
      direccion: nuevaDireccion.direccion,
      estado_provincia: nuevaDireccion.estado_provincia,
      codigo_postal: nuevaDireccion.codigo_postal,
    });

    setDirecciones([...direcciones, res.data]);
    setFormMembrete({ ...formMembrete, direccion_id: res.data.id });

    // resetear objeto
    setNuevaDireccion({
      nombre: "",
      direccion: "",
      estado_provincia: "",
      codigo_postal: "",
    });
    setShowModal(false);
  } catch (err) {
    console.error(err);
    mostrarMensaje("danger", "Error al crear la dirección.");
  }
};

const handleEditarDireccion = async () => {
  try {
    const res = await api.put(`/direcciones-envio/${direccionEditando.id}`, {
      nombre: nuevaDireccion.nombre,
      direccion: nuevaDireccion.direccion,
      estado_provincia: nuevaDireccion.estado_provincia,
      codigo_postal: nuevaDireccion.codigo_postal,
    });

    // actualizar lista local
    setDirecciones((prev) =>
      prev.map((d) => (d.id === direccionEditando.id ? res.data : d))
    );

    // actualizar selección en el membrete
    setFormMembrete({ ...formMembrete, direccion_id: res.data.id });

    mostrarMensaje("success", "Dirección actualizada correctamente");

    // resetear estados
    setNuevaDireccion({
      nombre: "",
      direccion: "",
      estado_provincia: "",
      codigo_postal: "",
    });
    setDireccionEditando(null);
    setShowModal(false);
  } catch (err) {
    console.error(err);
    mostrarMensaje("danger", "Error al actualizar la dirección.");
  }
};

 
  // -------------------- HANDLERS PAGO --------------------
  const handleChangePago = (e) => {
    const { name, value } = e.target;
    setFormPago({ ...formPago, [name]: value });
  };

  const handleEditarPago = async (pago) => {
  const clienteId = pago.cliente_id || pago.cliente_principal?.id || "";
  const citaId = pago.cita_id;

  // 1) Carga citas del cliente
   await cargarCitasPorCliente(clienteId);

  // 2) Si la cita a editar no quedó en citasFiltradas (p. ej. por filtro de año),
  //    la agregamos desde 'citas' globales.
  setCitasFiltradas((prev) => {
    const yaExiste = prev.some((c) => String(c.id) === String(citaId));
    if (yaExiste) return prev;
    const desdeGlobal = citas.find((c) => String(c.id) === String(citaId));
    return desdeGlobal ? [...prev, desdeGlobal] : prev;
  });
    setFormPago({
      cita_id: pago.cita_id || "",
      cliente_id: pago.cliente_id || pago.cliente_principal?.id || "",
      estado_pago_id: pago.estado_pago_id || "",
      monto: pago.monto || "",
      tipo_pago_id: pago.tipo_pago_id || "",
      observacion_pago: pago.observacion_pago || "",
    });
    setEditandoPago(true);
    setIdPagoActual(pago.id);
  };

  const resetFormPago = () => {
    setFormPago({
      cita_id: "",
      cliente_id: "",
      estado_pago_id: "",
      monto: "",
      tipo_pago_id: "",
      observacion_pago: "",
    });
    setEditandoPago(false);
    setIdPagoActual(null);
  };

  // -------------------- HANDLERS MEMBRETE --------------------
  const handleTiposMembrete = (e) => {
    const { value, checked } = e.target;
    setFormMembrete((prev) => {
      let nuevosTipos = [...prev.tipos_membrete];
      if (checked) {
        nuevosTipos.push(value);
      } else {
        nuevosTipos = nuevosTipos.filter((id) => id !== value);
      }
      return { ...prev, tipos_membrete: nuevosTipos };
    });
  };

  const handleChangeMembrete = (e) => {
    const { name, value } = e.target;
    setFormMembrete({ ...formMembrete, [name]: value });
  };

  const handleEditarMembrete = (membrete) => {
  setFormMembrete({
    cliente_id: membrete.cliente_id?.toString() || "",
    cita_id: membrete.cita_id?.toString() || "",
    tipos_membrete: membrete.tipos_membrete?.map((tm) => tm.id) || [],
    direccion_id: membrete.direccion_id || "",
    observaciones: membrete.observaciones || "",
    estado_pago_id: membrete.estado_pago_id || "",
  });

  // Cargar citas del cliente si es necesario
  if (membrete.cliente_id) {
    cargarCitasPorCliente(membrete.cliente_id);
  }

  setEditandoMembrete(true);
  setIdMembreteActual(membrete.id);
};

  const resetFormMembrete = () => {
    setFormMembrete({
      tipos_membrete: [],
      direccion_id: "",
      observaciones: "",
    });
    setEditandoMembrete(false);
    setIdMembreteActual(null);
  };

    // -------------------- HANDLERS PAGO -MEMBRETE --------------------
   // Pago
const guardarPago = async () => {
  const clienteIdNum = Number(formPago.cliente_id);
  const citaIdNum = Number(formPago.cita_id);

  const existePago = pagos.some(
    (p) =>
      Number(p.cliente_id || p.cliente_principal?.id) === clienteIdNum &&
      Number(p.cita_id) === citaIdNum &&
      (!editandoPago || p.id !== idPagoActual)
  );

  if (existePago) {
    mostrarMensaje("warning", "Ya existe otro pago para este cliente y esta cita.");
    return false;
  }

  const payload = {
    cita_id: citaIdNum,
    estado_pago_id: Number(formPago.estado_pago_id),
    tipo_pago_id: formPago.tipo_pago_id ? Number(formPago.tipo_pago_id) : null,
    monto: formPago.monto ? parseFloat(formPago.monto) : null,
    observacion_pago: formPago.observacion_pago || null,
    cliente_id: clienteIdNum || null,
  };

  if (editandoPago) {
    await api.put(`/pagos/${idPagoActual}`, payload);
    mostrarMensaje("success", "Pago actualizado correctamente");

   
  
  } else {
    await api.post("/pagos/", payload);
    mostrarMensaje("success", "Pago creado correctamente");
  }

  cargarPagos();
  cargarMembretes();
  return true;
};

// Membrete
const guardarMembrete = async () => {
  const clienteIdNum = Number(formMembrete.cliente_id);
  const citaIdNum = Number(formMembrete.cita_id);
  const tipos = formMembrete.tipos_membrete.map((t) => Number(t));

  const responseExistentes = await api.get("/membretes/", {
    params: { buscar: "", skip: 0, limit: 1000 },
  });
  const existentes = responseExistentes.data.resultados;

  if (!editandoMembrete) {
    const tiposNuevos = tipos.filter(
      (tipo) =>
        !existentes.some(
          (m) =>
            m.cita_id === citaIdNum &&
            m.cliente_id === clienteIdNum &&
            m.tipo_membrete_id === tipo
        )
    );
    if (tiposNuevos.length === 0) {
      mostrarMensaje("warning", "Ya existen todos los membretes seleccionados.");
      return false;
    }

    await api.post("/membretes/", {
      cita_id: citaIdNum,
      cliente_id: clienteIdNum,
      estado_pago_id: Number(formPago.estado_pago_id),
      direccion_id: formMembrete.direccion_id ? Number(formMembrete.direccion_id) : null,
      observaciones: formMembrete.observaciones || null,
      tipos_membrete: tiposNuevos,
    });

    mostrarMensaje("success", "Membrete(s) creado(s) correctamente");
  } else {
    const existeOtro = existentes.some(
      (m) =>
        m.id !== idMembreteActual &&
        m.cita_id === citaIdNum &&
        m.cliente_id === clienteIdNum &&
        m.tipo_membrete_id === tipos[0]
    );
    if (existeOtro) {
      mostrarMensaje("warning", "Ya existe otro membrete de este tipo.");
      return false;
    }

    await api.put(`/membretes/${idMembreteActual}`, {
      estado_pago_id: Number(formPago.estado_pago_id),
      direccion_id: formMembrete.direccion_id ? Number(formMembrete.direccion_id) : null,
      observaciones: formMembrete.observaciones || null,
      tipo_membrete_id: tipos[0],
    });

    mostrarMensaje("success", "Membrete actualizado correctamente");
  }

  return true;
};

const handleGuardarPagoYMembrete = async () => {
  try {
    const editandoPago = Boolean(idPagoActual);
    const editandoMembrete = Boolean(idMembreteActual);

    // Si solo estamos editando un pago
    if (editandoPago && !editandoMembrete) {
      const pagoOk = await guardarPago();
      if (!pagoOk) return;
    }

    // Si solo estamos editando un membrete
    else if (!editandoPago && editandoMembrete) {
      const membreteOk = await guardarMembrete();
      if (!membreteOk) return;
    }

    // Si estamos creando ambos o editando ambos juntos
    else {
      const pagoOk = await guardarPago();
      if (!pagoOk) return;
      await guardarMembrete();
    }

    resetFormPago();
    resetFormMembrete();
  } catch (err) {
    console.error(err);
    mostrarMensaje("danger", "Error al guardar");
  }
};


  //boton general para cancelar ambos formularios
const handleCancelar = () => {
  resetFormPago();
  resetFormMembrete();
};



  return (
    <div className="container mt-4">
      <h3 className="text-primary">Registrar Pago y Membrete</h3>
      {mensaje && (
  <div className={`alert alert-${mensaje.tipo} mt-3`} role="alert">
    {mensaje.texto}
  </div>
)}
      <Form>
  {/* DATOS GENERALES */}
  <h5 className="mt-3">Datos Generales</h5>
  <Row className="g-3">
    <Col xs={12} sm={6} md={4}>
      <Form.Group>
        <Form.Label>Buscar Cliente</Form.Label>
        <Form.Control
          type="text"
          placeholder="Escriba un nombre..."
          value={busquedaCliente}
          onChange={(e) => setBusquedaCliente(e.target.value)}
        />
      </Form.Group>
    </Col>

    <Col xs={12} sm={6} md={4}>
      <Form.Group>
        <Form.Label>Cliente</Form.Label>
        <Form.Select
          name="cliente_id"
          value={formPago.cliente_id}
          onChange={(e) => {
            const value = e.target.value;
            setFormPago({ ...formPago, cliente_id: value });
            setFormMembrete({ ...formMembrete, cliente_id: value });
            cargarCitasPorCliente(value);
          }}
        >
          <option value="">Seleccione cliente</option>
          {clientesFiltrados.map((c) => (
            <option key={c.id} value={c.id}>
              {c.nombres} {c.apellidos}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Col>

    <Col xs={12} sm={6} md={4}>
      <Form.Group>
        <Form.Label>Cita</Form.Label>
        <Form.Select
          name="cita_id"
          value={formPago.cita_id}
          onChange={(e) => {
            const value = e.target.value;
            setFormPago({ ...formPago, cita_id: value });
            setFormMembrete({ ...formMembrete, cita_id: value });
          }}
        >
          <option value="">Seleccione cita</option>
          {citasFiltradas.map((c) => (
            <option key={c.id} value={c.id.toString()}>
              {c.cliente?.nombres} {c.cliente?.apellidos} - Cita {c.id} -{" "}
              {c.fecha} {c.hora}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Col>

    <Col xs={12} sm={6} md={4}>
      <Form.Group>
        <Form.Label>Estado de Pago</Form.Label>
        <Form.Select
          name="estado_pago_id"
          value={formPago.estado_pago_id}
          onChange={(e) => {
            const value = e.target.value;
            setFormPago({ ...formPago, estado_pago_id: value });
            setFormMembrete({ ...formMembrete, estado_pago_id: value });
          }}
        >
          <option value="">Seleccione estado</option>
          {estadosPago.map((e) => (
            <option key={e.id} value={e.id}>
              {e.nombre}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Col>
  </Row>

  {/*  FORMULARIO PAGO */}
  <h5 className="mt-4">Formulario Pago</h5>
  <Row className="g-3">
    <Col xs={12} sm={6} md={4}>
      <Form.Group>
        <Form.Label>Monto</Form.Label>
        <Form.Control
          type="number"
          name="monto"
          value={formPago.monto}
          onChange={(e) =>
            setFormPago({ ...formPago, monto: e.target.value })
          }
          placeholder="0.00"
        />
      </Form.Group>
    </Col>

    <Col xs={12} sm={6} md={4}>
      <Form.Group>
        <Form.Label>Tipo de Pago</Form.Label>
        <Form.Select
          name="tipo_pago_id"
          value={formPago.tipo_pago_id}
          onChange={(e) =>
            setFormPago({ ...formPago, tipo_pago_id: e.target.value })
          }
        >
          <option value="">Seleccione tipo</option>
          {tiposPago.map((t) => (
            <option key={t.id} value={t.id}>
              {t.nombre}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
    </Col>

    <Col xs={12} sm={6} md={4}>
      <Form.Group>
        <Form.Label>Observación Pago</Form.Label>
        <Form.Control
          type="text"
          name="observacion_pago"
          value={formPago.observacion_pago}
          onChange={(e) =>
            setFormPago({ ...formPago, observacion_pago: e.target.value })
          }
        />
      </Form.Group>
    </Col>
  </Row>
 

  {/*  FORMULARIO MEMBRETE */}
  <h5 className="mt-4">Formulario Membrete</h5>
  <Row className="g-3">
    <Col xs={12} sm={6} md={4}>
      <Form.Group>
        <Form.Label>Tipos de Membrete</Form.Label>
        <div>
          {tiposMembrete.map((tm) => (
            <Form.Check
              key={tm.id}
              type="checkbox"
              label={tm.nombre}
              value={tm.id}
              checked={formMembrete.tipos_membrete.includes(tm.id)}
              onChange={handleTiposMembreteForm}
            />
          ))}
        </div>
      </Form.Group>
    </Col>

    <Col xs={12} sm={6} md={6}>
      <Form.Group>
        <Form.Label>Dirección</Form.Label>
        <div className="d-flex">
          <Form.Select
            name="direccion_id"
            value={formMembrete.direccion_id}
            onChange={(e) =>
              setFormMembrete({ ...formMembrete, direccion_id: e.target.value })
            }
          >
            <option value="">Seleccione dirección</option>
            {direcciones.map((d) => (
              <option key={d.id} value={d.id}>
                {d.nombre} - {d.direccion}- {d.estado_provincia} 
              </option>
            ))}
          </Form.Select>
<Button
  variant="secondary"
  className="ms-2"
  onClick={() => setShowModal(true)}
>
  +
</Button>

<Button
  variant="warning"
  className="ms-2"
  disabled={!formMembrete.direccion_id}
  onClick={() => {
    const dir = direcciones.find(
      (d) => d.id === Number(formMembrete.direccion_id)
    );
    if (dir) {
      setDireccionEditando(dir); // activa modo edición
      setNuevaDireccion({
        nombre: dir.nombre,
        direccion: dir.direccion,
        estado_provincia: dir.estado_provincia,
        codigo_postal: dir.codigo_postal,
      });
      setShowModal(true);
    }
  }}
>
  ✎
</Button>

        </div>
      </Form.Group>
    </Col>

    <Col xs={12} sm={6} md={4}>
      <Form.Group>
        <Form.Label>Observaciones</Form.Label>
        <Form.Control
          type="text"
          name="observaciones"
          value={formMembrete.observaciones}
          onChange={(e) =>
            setFormMembrete({ ...formMembrete, observaciones: e.target.value })
          }
        />
      </Form.Group>
    </Col>
  </Row>
  <Button onClick={handleGuardarPagoYMembrete} className="mt-3">
    {editandoMembrete ? "Actualizar " : "Guardar "}
  </Button>

  {/* CANCELAR GLOBAL */}
  <Button
    variant="secondary"
    className="mt-3 ms-2"
    onClick={() => {
      resetFormPago();
      resetFormMembrete();
    }}
  >
    Cancelar
  </Button>
</Form>

      <h5 className="mt-4">Lista de Pagos</h5>
      <Form.Group className="mb-3" style={{ maxWidth: "300px" }}>
      <Form.Label>Filtrar por Estado de Pago</Form.Label>
        <Form.Select
          value={filtroEstadoPago}
          onChange={(e) => {
            setFiltroEstadoPago(e.target.value);
            //setPagina(1); // reinicia a primera página
          }}
        >
          <option value="">Todos</option>
          {estadosPago.map((estado) => (
            <option key={estado.id} value={estado.id}>
              {estado.nombre}
            </option>
          ))}
        </Form.Select>
      </Form.Group>

      <Table striped bordered>
        <thead>
          <tr>
            <th>ID</th>
            <th>Cita ID</th>
            <th>Cliente</th>
            <th>Estado</th>
            <th>Tipo</th>
            <th>Monto</th>
            <th>Fecha</th>
            <th>Observacion</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
           {pagos.map((pago) => {
      const cliente = pago?.cliente_principal;
      return (
        <tr key={pago.id}>
          <td>{pago.id}</td>
          <td>{pago.cita_id}</td>
          <td>
            {cliente
              ? cliente.tipo_cliente_id === 1
                ? cliente.nombres
                : `${cliente.nombres || ""} ${cliente.apellidos || ""}`
              : "No disponible"}
          </td>
          <td>
            {estadosPago?.find((e) => e.id === pago.estado_pago_id)?.nombre ||
              "Sin estado"}
          </td>
          <td>
            {tiposPago?.find((t) => t.id === pago.tipo_pago_id)?.nombre ||
              ""}
          </td>
          <td>
            {pago.monto != null
              ? `$${parseFloat(pago.monto).toFixed(2)} USD`
              : "-"}
          </td>
          <td>
            {pago.fecha_pago || pago.fecha
              ? new Date(pago.fecha_pago || pago.fecha).toLocaleDateString()
              : "-"}
          </td>
          <td>{pago.observacion_pago || " "}</td>
          <td>
                  <button onClick={() => handleEditarPago(pago)} className="btn btn-sm "
                    style={{ backgroundColor: "#4e73df", borderColor: "#1cc88a", color: "#fff" }} >
                    ✏ Editar
                  </button>{" "}
                  
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>

      {/* Modal para nueva dirección */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{direccionEditando ? "Editar Dirección" : "Nueva Dirección"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
  <Form.Group className="mb-2">
    <Form.Label>Nombre</Form.Label>
    <Form.Control
      type="text"
      value={nuevaDireccion.nombre}
      onChange={(e) =>
        setNuevaDireccion({ ...nuevaDireccion, nombre: e.target.value })
      }
    />
  </Form.Group>

  <Form.Group className="mb-2">
    <Form.Label>Dirección</Form.Label>
    <Form.Control
      value={nuevaDireccion.direccion}
      onChange={(e) =>
        setNuevaDireccion({ ...nuevaDireccion, direccion: e.target.value })
      }
    />
  </Form.Group>

  <Form.Group className="mb-2">
    <Form.Label>Estado / Provincia</Form.Label>
    <Form.Control
      value={nuevaDireccion.estado_provincia}
      onChange={(e) =>
        setNuevaDireccion({
          ...nuevaDireccion,
          estado_provincia: e.target.value,
        })
      }
    />
  </Form.Group>

  <Form.Group className="mb-2">
    <Form.Label>Código Postal</Form.Label>
    <Form.Control
      value={nuevaDireccion.codigo_postal}
      onChange={(e) =>
        setNuevaDireccion({
          ...nuevaDireccion,
          codigo_postal: e.target.value,
        })
      }
    />
  </Form.Group>
</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={() => {
    if (direccionEditando) {
      handleEditarDireccion();
    } else {
      handleCrearDireccion();
    }
  }}>
            Guardar
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Paginación */}
                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <Button variant="secondary" disabled={pagina === 1} onClick={() => setPagina(p => p - 1)}>← Anterior</Button>
                      <span>Página {pagina} de {Math.ceil(totalPagos / pagosPorPagina)}</span>
                      <Button variant="secondary" disabled={pagina === Math.ceil(totalPagos / pagosPorPagina)} onClick={() => setPagina(p => p + 1)}>Siguiente →</Button>
              </div>
    </div>
  );
};

export default RegistrarPagoYMembrete;
